import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #PAGINATION-ITEM
\*------------------------------------ */
/**
 * Pagination link
 */
.cat-c-pagination__link {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  padding: calc(var(--size-base-unit) * 1) calc(var(--size-base-unit) * 2);
  display: flex;
  text-decoration: none;
  cursor: pointer;
  border-radius: var(--cat-theme-border-radius);
  border-width: var(--cat-border-width-md);
  border-style: solid;
  background-color: var(--cat-theme-color-button-link-background);
  color: var(--cat-theme-color-button-link-content);
  border-color: var(--cat-theme-color-button-link-border);
  /**
   * Set the prev/next icon styles to pass down
   */
  /**
   * Pagination link within active pagination item
   * 1) Current item on the page
   */
  /**
   * Pagination link within pagination item divider
   * 1) Remove any kind of pointer events to disable action since this is just
   * a visual treatment to separate a skip in the pages (e.g. 1, ..., 22)
   */
  /**
   * Pagination link within disabled pagination item
   */
}
.cat-c-pagination__link {
  --cat-icon-fill: var(--cat-theme-color-content-default);
}
.cat-c-pagination__link:hover, .cat-c-pagination__link:focus {
  background-color: var(--cat-theme-color-button-link-background-hover);
  border-color: var(--cat-theme-color-button-link-border-hover);
  color: var(--cat-theme-color-button-link-content-hover);
}
.cat-c-pagination__link:active {
  background-color: var(--cat-theme-color-button-link-background-active);
  border-color: var(--cat-theme-color-button-link-border-active);
  color: var(--cat-theme-color-button-link-content-active);
}
.cat-c-pagination__link:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-pagination__item.cat-is-active .cat-c-pagination__link {
  background-color: var(--cat-theme-color-button-background);
  border-color: var(--cat-theme-color-button-border);
  color: var(--cat-theme-color-button-link-content-hover);
}
.cat-c-pagination__item.cat-is-active .cat-c-pagination__link:hover, .cat-c-pagination__item.cat-is-active .cat-c-pagination__link:focus {
  background-color: var(--cat-theme-color-button-background-hover);
  border-color: var(--cat-theme-color-button-border-hover);
  color: var(--cat-theme-color-button-content-hover);
}
.cat-c-pagination__item.cat-is-active .cat-c-pagination__link:active {
  background-color: var(--cat-theme-color-button-background-active);
  border-color: var(--cat-theme-color-button-border-active);
  color: var(--cat-theme-color-button-content-active);
}
.cat-c-pagination__item.cat-is-active .cat-c-pagination__link:disabled {
  background-color: var(--cat-theme-color-button-background-disabled);
  border-color: var(--cat-theme-color-button-border-disabled);
  color: var(--cat-theme-color-button-content-disabled);
}
.cat-c-pagination__item--divide .cat-c-pagination__link {
  align-items: end;
}
.cat-c-pagination__item--divide .cat-c-pagination__link:hover, .cat-c-pagination__item--divide .cat-c-pagination__link:focus {
  color: var(--cat-theme-color-content-strong);
}
.cat-c-pagination__item--disabled .cat-c-pagination__link {
  pointer-events: auto;
  cursor: not-allowed;
  /**
   * Set the disabled prev/next icon styles to pass down
   */
  --cat-icon-fill: var(--cat-theme-color-button-primary-content-disabled);
}
.cat-c-pagination__link ::slotted(cat-contextual-menu) {
  color: var(--cat-theme-color-content-strong);
}
`;
       